// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__35v9D","selected":"Chip_selected__28CMv"};